export default __webpack_public_path__ + "static/media/exit.4634e280.png";